import { gql } from "@apollo/client";

export const GET_ACCOMMODATION_TYPES = gql`
  query getAccommodationTypes {
    accommodationTypes {
      id
      name
      code
      isArchived
      translations {
        name
        language
      }
    }
  }
`;
